/**
 * Conversion factor from Density-Independent Pixels (DP) to
 * distance-independent millimeters (DMM).
 */
export const DP_TO_DMM = 0.868;
